import {axiosApiInstance} from "../AxiosUtils";

export const getDashboard = (permissions, umbrellaExternalId, charityExternalId) => {
    const rolePath = (permissions === 'admin' ? 'admin' : 'umbrellad');

    const params = [];
    if (umbrellaExternalId != null) {
        params.push(`umbrella_id=${umbrellaExternalId}`);
    }
    if (charityExternalId != null) {
        params.push(`charity_id=${charityExternalId}`);
    }
    const requestParams = params.length ? `?${params.join('&')}` : '';

    return axiosApiInstance.get(`${process.env.REACT_APP_API_URL}/api/v2/${rolePath}/dashboard${requestParams}`);
}

export const getCharityDashboard = () => axiosApiInstance.get(`${process.env.REACT_APP_API_URL}/api/v2/charitad/dashboard`);
